
export default function Loader() {
    return (
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[1000]">
            <div className="text-gray-300 dark:text-gray-600 inline-block w-20 h-20 after:content-[''] after:block after:w-16 after:h-16 after:m-2 after:rounded-full after:border-[6.4px] after:border-current after:border-t-transparent after:border-b-transparent after:animate-spin"></div>
        </div>
    )
}
